import { cx } from '@linaria/core';
import { Tooltip } from '@ui/kit';
import { printHtmlNodesToJsx } from '@utils/ast';
import { Chevron } from '@utils/react';
import { heading, collapseChevron, headingDescription, title } from './atom.title.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function ComponentFrameworkTitle(props) {
  return /*#__PURE__*/jsxs("span", {
    className: cx(title, props.className, !!props.onCollapse && "collapsible"),
    children: [/*#__PURE__*/jsx("h3", {
      className: heading,
      onClick: props.onCollapse,
      children: props.title
    }), props.onCollapse && /*#__PURE__*/jsx(Tooltip, {
      ariaType: "label",
      body: "Luk opgaven",
      placement: "right",
      children: ref => /*#__PURE__*/jsx("button", {
        ref: ref,
        className: collapseChevron,
        onClick: props.onCollapse,
        children: /*#__PURE__*/jsx(Chevron, {
          vertical: true,
          size: 10,
          inversed: true,
          lineWidth: 2
        })
      })
    }), !!props.richtextDescription?.length && /*#__PURE__*/jsx("div", {
      className: headingDescription,
      children: printHtmlNodesToJsx(props.richtextDescription)
    })]
  });
}

export { ComponentFrameworkTitle };
//# sourceMappingURL=atom.title.js.map
